<template>
	<footer
		id="theme-footer"
		class="font-size--20 theme-footer content-padding main-font padding-top-xl padding-bottom-sm"
	>
		<div class="container info">
			<div class="top-footer">
				<div class="logo">
					<PageLogo :dark="true" />
				</div>

				<div
					v-if="footerOpt && (footerOpt.social_media.social_media || footerOpt.singup_footer)"
					class="social"
				>
					<SocialLinks
						v-if="footerOpt.social_media.length"
						:light="false"
						:socials="footerOpt.social_media"
					/>
					<Button
						button
						class="newsletter-singup"
						@click.native="newsletterSingup"
						theme="light"
						icon="envelop"
						v-if="footerOpt.singup_footer && footerOpt.nesletter_form"
					>
						Sign up for newsletter
					</Button>
				</div>
			</div>

			<ul
				v-if="footerOpt && footerOpt.links && footerOpt.links.length"
				class="margin-top-lg margin-bottom-md footer-link"
			>
				<li v-for="({ link }, k) in footerOpt.links" :key="k" class="item">
					<AcfLink class="slide-hover slide-hover--white" :data="link" />
				</li>
			</ul>

			<div v-if="footerOpt" class="footer-middle margin-bottom-lg margin-top-md">
				<div v-if="footerOpt.text_block" class="footer-desc" v-html="footerOpt.text_block"></div>
				<div v-if="footerOpt.partnership && footerOpt.partnership.length" class="spec-partners partnership">
					<div class="inner">
						<a
							v-for="({ link, logo, name }, k) in footerOpt.partnership"
							:key="k"
							rel="nofollow noopener"
							terget="_blank"
							:title="name"
							:href="link"
						>
							<WpImage :radius="false" :image="logo" />
						</a>
					</div>
				</div>
			</div>

			<div v-if="footerOpt && footerOpt.partners && footerOpt.partners.length" class="footer-partners">
				<h4 class="partners-title font-size--20" v-if="footerOpt.partners_title">
					{{ footerOpt.partners_title }}
				</h4>
				<ul class="partners-list">
					<li v-for="({ link, logo, name }, k) in footerOpt.partners" :key="k" class="item">
						<a terget="_blank" :title="name" rel="nofollow noopener" :href="link">
							<WpImage :radius="false" :image="logo" />
						</a>
					</li>
				</ul>
			</div>
		</div>

		<div class="container copyright font-size--16">
			<div class="page">
				© Copyright {{ currentYear }} {{ blogName }}.
				<template v-if="wpvue && wpvue.pages && wpvue.pages.privacy && wpvue.pages.privacy.link">
					Read our
					<WpLink :url="wpvue.pages.privacy.link" class="slide-hover slide-hover--white slide-hover--tiny">
						privacy policy
					</WpLink>
				</template>
			</div>
			<div class="dev">
				Delivered by
				<a
					href="//frontkom.com"
					class="slide-hover slide-hover--white slide-hover--tiny"
					rel="nofollow noopener"
				>
					Frontkom
				</a>
			</div>
		</div>
	</footer>
</template>

<script>
import PageLogo from '@/components/elements/PageLogo'
import AcfLink from '@/components/elements/AcfLink'
import WpImage from '@/components/elements/WpImage'
import WpLink from '@/components/elements/WpLink'
import SocialLinks from '@/components/parts/SocialLinks'
import Button from '@/components/elements/Button'

import { mapGetters, mapMutations } from 'vuex'

export default {
	name: 'theme-footer',
	components: {
		AcfLink,
		PageLogo,
		SocialLinks,
		WpImage,
		Button,
		WpLink,
	},
	data() {
		return {
			homeLink: window.WPVUE.home.replace(/\/$/, ''),
			wpvue: window.WPVUE,
			isFormOpen: false,
			blogName: window.WPVUE.blogname,
			currentYear: new Date().getFullYear(),
		}
	},
	computed: {
		...mapGetters(['getOptions']),

		footerOpt() {
			const { footer } = this.getOptions
			return footer || false
		},
	},
	methods: {
		...mapMutations(['NEWSLETTER_MODAL_CHANGE_STATE']),
		newsletterSingup() {
			this.NEWSLETTER_MODAL_CHANGE_STATE()
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.theme-footer {
	font-family: $secndaryFont;
	//margin-top: 150px;
	background-color: var(--alwaysDark);
	color: var(--alwaysLight);
	margin-top: 50px;
	.info {
		@include mquery($phone) {
			padding: 0;
		}
	}
	.page-logo {
		img {
			max-width: 125px;
			@include mquery($tablet) {
				max-width: 100px;
			}
		}
	}
	.copyright {
		display: flex;
		justify-content: space-between;
		@include mquery($phone) {
			flex-direction: column;
		}
		a {
			text-decoration: none;
		}
	}
	.social {
		display: flex;
		@include mquery($phone) {
			display: block;
			margin-top: 15px;
		}
	}
	.newsletter-singup {
		margin-left: 25px;
		@include mquery($phone) {
			margin-left: 0;
			margin-top: 25px;
		}
	}
	.top-footer {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		@include mquery($phone) {
			flex-direction: column;
		}
	}
	.footer-link {
		padding: 0;
		list-style: none;
		display: flex;
		flex-wrap: wrap;
		li {
			margin-right: 50px;
			margin-bottom: 10px;
			&:last-child {
				margin-right: 0;
			}
			@include mquery($phone) {
				margin-right: 25px;
			}
		}
		a {
			text-decoration: none;
			font-weight: 600;
		}
	}
	.footer-middle {
		display: flex;
		justify-content: space-between;
		align-items: center;
		@include mquery($tablet) {
			flex-direction: column;
		}
		.footer-desc {
			max-width: 700px;
			width: 100%;
		}
		.spec-partners {
			background: #fff;
			margin-left: 25px;
			padding: 25px;
			border-radius: $radius;
			@include mquery($tablet) {
				margin-left: 0;
				padding: 15px;
			}

			.inner {
				display: flex;
				a {
					display: inline-block;
					margin-right: 25px;
					line-height: 1;
					&:last-child {
						margin-right: 0;
					}
				}
				img {
					width: auto;
					width: 100%;
					max-height: 66px;
					&[src*='svg'] {
						max-width: 156px;
					}
				}
			}
		}
	}

	.footer-partners {
		margin-bottom: 35px;
		.partners-title {
			margin-bottom: 15px;
		}
		.partners-list {
			margin: 0;
			padding: 0;
			list-style: none;
			display: flex;
			flex-wrap: wrap;
			margin-left: -12px;
			margin-right: -12px;
			a {
				display: inline-block;
			}
			li {
				margin: 12px;
				img {
					width: auto;
					height: 34px;
				}
			}
		}
	}
}
</style>
